import { Article } from "../utils/blogUtils";

import { atomWithStorage } from "jotai/utils";

export const articlesAtom = atomWithStorage<Record<string, Article>>(
  "articlesAtom",
  {},
  undefined,
  { getOnInit: true }
);
